<template>
  <ul class="el-timeline">
    <li class="el-timeline-item" v-for="item in imgDateList" :key="item.date">
      <div class="el-timeline-item__tail"></div>
      <div
        class="el-timeline-item__node el-timeline-item__node--normal el-timeline-item__node--primary"
      >
        <img src="~@/assets/images/time_line_ico.svg" alt="" />
      </div>
      <div class="el-timeline-item__wrapper">
        <div class="timeline-header">
          <div class="time">{{ item.date }}</div>
          <div
            class="toggle"
            @click="toggleHide(item)"
            v-if="item.list.length != 0 && imgDateList.length != 1"
          >
            <span class="text">{{ !item.hide ? "收起" : "展开" }}</span>
            <i :class="`icon-arrow-${!item.hide ? 'up' : 'down'}`"></i>
          </div>
        </div>
        <div v-show="!item.hide" class="el-timeline-item__content">
          <div
            v-for="(img, index) in item.list"
            :key="index"
            class="img-wrap"
            @click="showDetail(img)"
          >
            <div class="img-inner">
              <img :src="img.url" alt="投图" />
            </div>
          </div>
        </div>
        <div class="empty" v-if="item.list.length == 0">
          <div class="tip">当前日期暂无投图</div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "picTimeline",
  props: {
    imgDateList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      show: true,
      selectedItemId: null,
    };
  },
  methods: {
    toggleHide(item) {
      item.hide = !item.hide;
    },
    showDetail(item) {
      this.selectedItemId = item.file_cdn_id;
      this.$emit("showDetail", item.url);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-timeline {
  padding-top: 4px;
}
.el-timeline-item__node--normal {
  left: 0;
  top: -3px;
  width: 16px;
  height: 16px;
}

.el-timeline-item__tail {
  left: 7px;
}

.timeline-header {
  display: flex;
  align-items: center;

  .time {
    font-size: 16px;
    color: #202020;
    margin-right: 10px;
    font-weight: 500;
  }

  .toggle {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #027bfe;
    cursor: pointer;

    .text {
      margin-right: 4px;
    }

    i {
      display: block;
      width: 0.16rem;
      height: 0.16rem;

      &.icon-arrow-up {
        background: url("~@/assets/images/triangle_arrow_gray_up.svg") no-repeat
          center center;
        background-size: contain;
      }
      &.icon-arrow-down {
        background: url("~@/assets/images/triangle_arrow_gray_down.svg")
          no-repeat center center;
        background-size: contain;
      }
    }
  }
}

.el-timeline-item__content {
  padding: 12px 0 4px 0;
  overflow: hidden;

  .img-wrap {
    float: left;
    width: 110px;
    height: 110px;
    margin-right: 24px;
    margin-bottom: 20px;
    background: #eceef5;
    cursor: pointer;
    border: 1px solid #fff;

    &.selected {
      border-color: #037bfe;
    }

    .img-inner {
      height: 100%;
      display: flex;
      justify-content: center;
    }

    img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 308px;

  .tip {
    font-size: 16px;
    color: #606060;
    font-weight: 500;
  }
}
</style>